import React from 'react';
import { useStyles } from '../../contexts/StyleContext';

const TextArea = ({
  label,
  error,
  className = '',
  rows = 4,
  ...props
}) => {
  const styles = useStyles();
  const { form } = styles;

  const textareaClasses = `
    w-full 
    px-4 
    py-3 
    rounded-lg 
    border-2 
    bg-white 
    transition-all 
    duration-200
    focus:ring-2
    resize-none
    ${error ? 'border-red-500' : ''}
    ${className}
  `.trim();

  const textareaStyle = {
    borderColor: error ? '#EF4444' : form.input.border,
    ':focus': {
      borderColor: form.input.focus.border,
      '--tw-ring-color': form.input.focus.ring
    }
  };

  const labelClasses = `
    block 
    text-sm 
    font-semibold 
    uppercase 
    tracking-wide 
    mb-2
  `.trim();

  const labelStyle = {
    color: form.label.color
  };

  const errorClasses = `
    mt-1 
    text-sm 
    text-red-500
  `.trim();

  return (
    <div className="mb-4">
      {label && (
        <label 
          className={labelClasses}
          style={labelStyle}
        >
          {label}
        </label>
      )}
      <textarea
        className={textareaClasses}
        style={textareaStyle}
        rows={rows}
        {...props}
      />
      {error && (
        <p className={errorClasses}>{error}</p>
      )}
    </div>
  );
};

export default TextArea;
